import { useQuery } from 'react-query';
import { getAutopay } from '../../../../../actions/Utilities/VendorConfiguration';


export default function useGetAutopay() {
  return useQuery("useGetAutopay", getAutopay, {
    refetchOnWindowFocus: false,
  });
}

